/* eslint-disable react/prop-types */

import Image from "next/image";
import Link from "next/link";
import { sanitize, adjustColor  } from '@/utils/misc';
import studioStore from '@/stores/studioStore';

function ImageContentSideBySide({sectionImage, sectionLink, backgroundColor = "#ffffff", sectionContainer, sectionTitle, sectionText, sectionButtonText}) {
  const primaryColor = studioStore.settings.colors.primary_color;
  const hoverPrimaryColor = adjustColor(primaryColor, -30);
  let classes = "w-full h-full";
  const style = {
    backgroundColor: backgroundColor,
  };

  if (sectionContainer === "stamp") {
    classes = "stamp-border w-[calc(100%+2rem)] h-[calc(100%+2rem)] -m-[1rem]";
    style.backgroundImage = `radial-gradient(8px, transparent 98%, ${backgroundColor}),linear-gradient(${backgroundColor} 0px, ${backgroundColor} 0px)`;
    style.backgroundColor = '';
  }
  return (
    <div className="section-image-content-side-by-side mb-8" style={{backgroundColor: backgroundColor}}>
      <div className="container mx-auto">
        <div className="flex flex-col md:flex-row overflow-hidden">
          <div className="w-full md:w-[55%] z-10">
            <div className={classes} style={style}>
              <div className="section-image-content-side-by-side-content px-12 lg:ps-20 lg:pe-32 py-6 lg:py-16">
                {sectionTitle && (
                  <>
                    <h2 className="text-xl md:text-2xl 2xl:text-3xl mb-2 font-secondary text-primary-studio" dangerouslySetInnerHTML={{ __html: sanitize(sectionTitle)}} />
                    <hr className="dotted-spaced mb-4" />
                  </>
                )}
                {sectionText && (
                  <div className="mb-4 md:mb-5 2xl:mb-7" dangerouslySetInnerHTML={{ __html: sanitize(sectionText)}} />
                )}
                {sectionButtonText && sectionLink && (
                  <Link href={sectionLink}>
                    <button className="section-image-content-side-by-side-button text-white py-2 px-4 rounded-xl transition duration-300 font-secondary">
                      {sectionButtonText}
                    </button>
                  </Link>
                )}
              </div>
            </div>
          </div>
          <div className="w-full md:w-[45%]">
            <div
              style={{
                width: `${sectionImage.width}px`,
                height: "100%",
                minHeight: `200px`,
                maxWidth: "100%",
                overflow: "hidden",
                position: "relative",
              }}
              className="mx-auto"
            >
              {sectionLink ? (
                <Link href={sectionLink}>
                  <Image
                    src={sectionImage?.url || "/images/no-image.jpg"}
                    alt={sectionImage?.alt || "No image available"}
                    title={sectionImage.title || "Product image"}
                    fill
                    sizes={`(max-width: 768px) 100vw, (max-width: 1200px) 50vw, ${sectionImage.width}px`}
                    style={{ objectFit: "cover" }}
                    onError={(e) => {
                      e.target.src = "/images/no-image.jpg";
                    }}
                  />
                </Link>
              ) : (
                <Image
                  src={sectionImage?.url || "/images/no-image.jpg"}
                  alt={sectionImage?.alt || "No image available"}
                  title={sectionImage.title || "Product image"}
                  fill
                  sizes={`(max-width: 768px) 100vw, (max-width: 1200px) 50vw, ${sectionImage.width}px`}
                  style={{ objectFit: "cover" }}
                  onError={(e) => {
                    e.target.src = "/images/no-image.jpg";
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        .cta-button {
          background-color: ${primaryColor}
        }
        .cta-button:hover {
          background-color: ${hoverPrimaryColor};
        }
      `}</style>
    </div>
  )
}

export default ImageContentSideBySide